import '.hd{border-bottom:1px solid var(--brand-secondary);}.ssr-plugin'
import '.c{display:flex;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.he{padding:1.5rem 0;}.ssr-plugin'
import '.bd{border:none;}.ssr-plugin'
import '.f0{background:transparent;}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import '.f2{text-align:left;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.d8{width:1.5rem;}.ssr-plugin'
import '.hf{font-size:1.25rem;}.ssr-plugin'
import '.e6{font-weight:700;}.ssr-plugin'
import '.hg{padding-bottom:1.125rem;}.ssr-plugin'
import { useId, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { type Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'

export type FaqItemProps = {
  question: string
  answer: string
  style?: Style
}

export const FaqItem = ({ question, answer, style }: FaqItemProps) => {
  const baseId = useId()
  const panelId = `${baseId}-panel`
  const triggerId = `${baseId}-trigger`
  const [open, setOpen] = useState(false)

  return (
    <styled.div className="hd"
      style={{
        ...style,
      }}
    >
      <button className="c u he bd f0 ar f2"
        type="button"
        id={triggerId}
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((v) => !v)}
      >
        <Title.H3
          style={{
            flex: 1,
            margin: 0,
          }}
        >
          {question}
        </Title.H3>
        <span className="bn c h d d8 hf e6"
          aria-hidden
        >
          <FontAwesomeIcon icon={open ? faMinus : faPlus} />
        </span>
      </button>
      {open ? (
        <div className="hg"
          id={panelId}
          role="region"
          aria-labelledby={triggerId}
        >
          <Text.Medium
            style={{
              margin: 0,
              color: 'var(--brand-secondary)',
              opacity: 0.85,
              lineHeight: '1.45',
              fontWeight: 400,
            }}
          >
            {answer}
          </Text.Medium>
        </div>
      ) : null}
    </styled.div>
  )
}
